// extracted by mini-css-extract-plugin
export default {"Description":"P9hjIATKL_dXCzHrqZ9w","Readonly":"NBiq2F1LDUwqvfKS1o4P"};